import * as Helper from "../../../utils/Helper";
import ApiService from "../../ApiService";

const AdminLoginService = {
    Login: (email, password, userTableType, successCallback, failureCallback) => {
        var passwordHash = "";
        if (!Helper.isNullOrEmpty(password)) {
            let sha256 = require("crypto-js/sha256");
            passwordHash = sha256(password).toString();
        }

        ApiService.post("/account/otherlogin", { email, userTableType, password: passwordHash }, successCallback, failureCallback);
    },

    changePassword: (vo, successCallback, failureCallback) => { 
        const { password, newPassword, confirmPassword } = vo;
        let sha256 = require("crypto-js/sha256");  
        let passwordHash = "";
        if (!Helper.isNullOrEmpty(password)) {
            passwordHash = sha256(password).toString();
        }
        let newPasswordHash = "";
        if (!Helper.isNullOrEmpty(newPassword)) {
            newPasswordHash = sha256(newPassword).toString();
        }
        let confirmPasswordHash = "";
        if (!Helper.isNullOrEmpty(confirmPassword)) {
            confirmPasswordHash = sha256(confirmPassword).toString();
        }

        vo = { ...vo, password: passwordHash, newPassword: newPasswordHash, confirmPassword: confirmPasswordHash };
        
        ApiService.post("/account/changepasswordfirstlogin", vo, successCallback, failureCallback);
    }
};

export default AdminLoginService;